const Videos = document.getElementsByClassName('Video');

const Button = `<button class="Video-button">
        <svg class="Video-playIcon" xmlns="http://www.w3.org/2000/svg">
            <use xlink:href="#play"></use>
        </svg>
    </button>`;

for (let i = 0; i < Videos.length; i++) {
    const VideoId = Videos[i].getAttribute('data-id');
    const VideoBox = Videos[i].children[0];

    VideoBox.innerHTML = VideoBox.innerHTML + Button;

    const PlayButton = VideoBox.children[1];

    PlayButton.addEventListener('click', function() {
        Videos[i].classList.add('is-loaded');
        embedVideo(VideoId, VideoBox);
    });
}

function embedVideo(videoId, target) {
    const Iframe = `<iframe class="Video-embed" src="https://www.youtube.com/embed/${videoId}?autoplay=1" frameborder="0"></iframe>`;

    target.innerHTML = Iframe;
}
